import {Navigate, Route, Routes} from "react-router-dom";
import Warehouses from "./components/dictionary/sales_structure/warehouse/warehouses";
import Products from "./components/dictionary/products/products/product";
import Users from "./components/administrations/users/users";
import EditUser from "./components/administrations/users/edit-user";
import 'antd/dist/antd.css';
import Geography from "./components/dictionary/sales_structure/geography/geography";
import EditGeography from "./components/dictionary/sales_structure/geography/edit-geography";
import Distributors from "./components/dictionary/sales_structure/distributor/distributors";
import EditDistributor from "./components/dictionary/sales_structure/distributor/edit-distributor";
import Branches from "./components/dictionary/sales_structure/branch/branches";
import EditBranch from "./components/dictionary/sales_structure/branch/edit-branch";
import EditWarehouse from "./components/dictionary/sales_structure/warehouse/edit-warehouse";
import ProductsCategory from "./components/dictionary/products/products_category/products_category";
import EditProductsCategory from "./components/dictionary/products/products_category/edit-products_category";
import ProductsGroups from "./components/dictionary/products/products_group/products_group";
import EditProductsGroups from "./components/dictionary/products/products_group/edit-products_group";
import EditProducts from "./components/dictionary/products/products/edit-product";
import Menu2 from "./components/menu/menu2";
import {ConfigProvider, Layout} from 'antd';
import React, {Suspense, useEffect, useState} from "react";
import HeaderMenu from "./components/menu/header";
import Sider from "antd/es/layout/Sider";
import {Content} from "antd/es/layout/layout";
import OrgStructureTypes from "./components/dictionary/org-structure/types/org-structure-types";
import EditOrgStructureType from "./components/dictionary/org-structure/types/edit-org-structure-type";
import OrgStructures from "./components/dictionary/org-structure/org_structures";
import {ProtectedRoute} from "./components/menu/ProtectedRoute";
import EditOrgStructure from "./components/dictionary/org-structure/edit-org_structure";
import LoginPage from "./components/login/login";
import TradePointCategory from "./components/dictionary/trade-point/category/trade-point-category";
import EditTradePointsCategory from "./components/dictionary/trade-point/category/edit-trade-point-category";
import TradePointType from "./components/dictionary/trade-point/type/trade-point-type";
import EditTradePointsType from "./components/dictionary/trade-point/type/edit-trade-point-type";
import Chain from "./components/dictionary/trade-point/chain/chain";
import EditChain from "./components/dictionary/trade-point/chain/edit-chain";
import TRoute from "./components/dictionary/trade-point/route/route";
import EditTRoute from "./components/dictionary/trade-point/route/edit-route";
import TradePoint from "./components/dictionary/trade-point/trade-point/trade-point";
import EditTradePoint from "./components/dictionary/trade-point/trade-point/edit-trade-point";
import TypeReportingPeriod
    from "./components/dictionary/documents_setting/types_reporting_periods/type-reporting-period";
import EditTypeReportingPeriod
    from "./components/dictionary/documents_setting/types_reporting_periods/edit-type-reporting-period";
import ReportingPeriod from "./components/dictionary/documents_setting/reporting_period/reporting-period";
import EditReportingPeriod from "./components/dictionary/documents_setting/reporting_period/edit-reporting-period";
import PatternActivity from "./components/dictionary/documents_setting/pattern_activity/pattern-activity";
import EditPatternActivity from "./components/dictionary/documents_setting/pattern_activity/edit-pattern-activity";
import DocType from "./components/dictionary/documents_setting/doc_type/doc-type";
import EditDocType from "./components/dictionary/documents_setting/doc_type/edit-doc-type";
import Unit from "./components/dictionary/documents_setting/unit/unit";
import EditUnit from "./components/dictionary/documents_setting/unit/edit-unit";
import Sales from "./components/documents/sale/sales";
import Sale from "./components/documents/sale/sale";
import Remain from "./components/documents/remain/remain";
import EditRemain from "./components/documents/remain/edit-remain";
// import Equipment from "./components/equipment/equipment";
import Page_404 from "./components/tech/404";
import Page_505 from "./components/tech/505";
import UserSettings from "./components/user/setting";
import uk_UA from "antd/lib/locale/uk_UA";
// import ru_RU from "antd/lib/locale/ru_RU";
// import en_US from "antd/lib/locale/en_US";
import moment from "moment";
// import 'moment/locale/ru';
import 'moment/locale/uk';
// import 'moment/locale/es-us';
import Log from "./components/development/log/log";
import EditLog from "./components/development/log/edit-log";
import Documentation from "./components/development/documentation/documentation";
import logo_black from "./style/images/logo_black.png";
import Token from "./components/tech/authentications";
import DB_Auth from "./database/auth/auth";
import LoadPage from "./components/tech/load_page";
import ModalWindow from "./components/modal";
import {NewsMailing} from "./components/administrations/news_mailing/news-mailing";
import {EditNewsMailing} from "./components/administrations/news_mailing/edit-news-mailing";
import Cube from "./components/development/cub/cube";
import ReportSales from "./components/reports/report_sales";
import EditSale from "./components/documents/sale/edit_sale";
import PriceLists from "./components/dictionary/finance/price-lists/price-lists";
import PriceList from "./components/dictionary/finance/price-lists/price-list";
import PayForms from "./components/dictionary/finance/pay-forms/pay-forms";
import PayForm from "./components/dictionary/finance/pay-forms/pay-form";
import Debts from "./components/dictionary/finance/debts/debts";
import Debt from "./components/dictionary/finance/debts/debt";
import RemainsMobile from "./components/mobile/remains/remains_mobile";
import RemainMobile from "./components/mobile/remains/remain_mobile";
import Orders from "./components/mobile/orders/orders";
import Order from "./components/mobile/orders/order";
import Returns from "./components/mobile/returns/returns";
import Return from "./components/mobile/returns/return";
import RemainsTradePoints from "./components/mobile/remains_trade_points/remains_trade_points";
import RemainsTradePoint from "./components/mobile/remains_trade_points/remains_trade_point";
import Visits from "./components/mobile/visits/visits";
import Visit from "./components/mobile/visits/visit";
import Payments from "./components/mobile/payments/payments";
import Payment from "./components/mobile/payments/payment";
import EditOrder from "./components/mobile/orders/edit_order";
import EditReturn from "./components/mobile/returns/edit_return";
import LogsMobiles from "./components/development/log_mobile/logs_mobiles";
import LogMobile from "./components/development/log_mobile/log_mobile";
import Privacy from "./components/privacy/privacy";
import OperationTypes from "./components/dictionary/finance/operation_type/operation-types";
import OperationType from "./components/dictionary/finance/operation_type/operation_type";


export const Context = React.createContext();


function App() {
    const {getToken, saveToken, removeToken} = Token()
    const {errorConnect} = ModalWindow();

    // const {i18n} = useTranslation();
    const defaultPage = 1;
    const defaultPageSize = 50;

    const [loadPage, setLoadPage] = useState(true);
    const [loginPage, setLoginPage] = useState(false);
    const [errorPage, setErrorPage] = useState(false);
    const [token, setToken] = useState(getToken())
    const {authentications} = DB_Auth(token)


    const [user, setUser] = useState({
        id: null,
        name: null,
        role: null,
        role_id: null,
        branch: null,
        pattern_activity: null,
        avatar: null,
        // lang: null
    })

    const locale = uk_UA
    moment.locale('uk')

    //
    // const applyLocale = (locale) => {
    //     i18n.changeLanguage(locale);
    //
    //     switch (locale) {
    //         case 'en_US': {
    //             setLocale(en_US);
    //             moment.locale('en_us')
    //             break
    //         }
    //         case 'uk_UA': {
    //             setLocale(uk_UA);
    //             moment.locale('uk')
    //             break
    //         }
    //         case 'ru_RU': {
    //             setLocale(ru_RU);
    //             moment.locale('ru')
    //         }
    //
    //     }
    // }


    const auth = () => {
        authentications()
            .then(res => {
                saveToken(token)
                setUser({
                    id: res.data.id,
                    name: res.data.name,
                    role: res.data.role,
                    role_id: res.data.role_id,
                    branch: res.data.branch,
                    pattern_activity: res.data.pattern_activity,
                    avatar: res.data.avatar,
                    // lang: res.data.lang
                })
                // setUserRoles(res.data.user.roles)
                // applyLocale(res.data.lang)
                setLoadPage(false)
                setLoginPage(false)
            })
            .catch(e => {
                removeToken()
                if (e.request.status === 401) {
                    setLoadPage(false)
                    setLoginPage(true)
                } else {
                    errorConnect()
                    setErrorPage(true)
                }
            })
    }

    useEffect(() => {
        auth()
    }, [token])


    if (window.location.pathname === '/privacy') {
        return <Privacy/>
    } else if (loadPage) {
        return <LoadPage display={loadPage}/>
    } else if (loginPage) {
        return <LoginPage setToken={setToken} display={loginPage}/>
    } else if (errorPage) {
        return <Page_505/>
    } else {
        return (<>
                <LoadPage display={loadPage}/>
                <ConfigProvider locale={locale}>
                    <Suspense fallback="loading">
                        <Context.Provider value={{token, setToken, user, defaultPage, defaultPageSize, locale}}>
                            <Layout>
                                <Sider style={{borderRight: '1px solid #F0F0F0'}}>
                                    <Layout style={{background: '#fff'}}>
                                        <div style={{
                                            width: 'auto',
                                            height: '50pt',
                                            backgroundImage: `url(${logo_black})`,
                                            backgroundSize: '50pt',
                                            backgroundRepeat: 'no-repeat',
                                            margin: '10pt 0 10pt 20pt'
                                        }}/>
                                        <Menu2/>

                                    </Layout>
                                </Sider>
                                <Layout>
                                    <HeaderMenu/>
                                    <Content>
                                        <Routes>
                                            <Route path="/" element={<Navigate to='/site/documents/sales' />}/>

                                            <Route path="/site" >
                                                <Route path="*" element={<Page_404/>}/>

                                                {/*<Route path="/" element={<Dashboard/>}/>*/}


                                                <Route path="sales-structure">
                                                    {/*Warehouse*/}
                                                    <Route path="warehouses" element={<Warehouses/>}/>
                                                    <Route path="warehouses/:warehouse_id" element={<EditWarehouse/>}/>

                                                    {/*Geography*/}
                                                    <Route path="a-geography"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <Geography/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="a-geography/geography"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditGeography/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*Distributors*/}
                                                    <Route path="distributors"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <Distributors/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="distributors/distributor"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditDistributor/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*Branch*/}
                                                    <Route path="branches"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <Branches/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="branches/branch"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditBranch/>
                                                           </ProtectedRoute>}
                                                    />

                                                </Route>

                                                <Route path={'finance'}>
                                                    <Route path={'debts'} element={<Debts/>}/>
                                                    <Route path={'debts/:debt_id'} element={<Debt/>}/>

                                                    <Route path={'price-lists'} element={<PriceLists/>}/>
                                                    <Route path={'price-lists/:price_list_id'} element={<PriceList/>}/>

                                                    <Route path={'pay-forms'} element={<PayForms/>}/>
                                                    <Route path={'pay-forms/:pay_form_id'} element={<PayForm/>}/>

                                                    <Route path={'operation-types'} element={<OperationTypes/>}/>
                                                    <Route path={'operation-types/:operation_type_id'} element={<OperationType/>}/>

                                                </Route>


                                                {/*Products*/}
                                                <Route path="products/categories"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <ProductsCategory/>
                                                       </ProtectedRoute>}
                                                />
                                                <Route path="products/categories/category"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditProductsCategory/>
                                                       </ProtectedRoute>}
                                                />

                                                <Route path="products/groups"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <ProductsGroups/>
                                                       </ProtectedRoute>}
                                                />
                                                <Route path="products/groups/group"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditProductsGroups/>
                                                       </ProtectedRoute>}
                                                />

                                                <Route path="products" element={<Products/>}/>
                                                <Route path="products/product"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditProducts/>
                                                       </ProtectedRoute>}
                                                />

                                                {/*OrgStructure*/}
                                                <Route path="org-structures" element={<OrgStructures token={token}/>}/>
                                                <Route path="org-structures/:org_structure_id" element={<EditOrgStructure/>}/>

                                                {/*OrgStructure Type*/}
                                                <Route path="org-structures/types"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <OrgStructureTypes/>
                                                       </ProtectedRoute>}
                                                />
                                                <Route path="org-structures/types/type"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditOrgStructureType/>
                                                       </ProtectedRoute>}
                                                />

                                                {/*TradePoint*/}
                                                <Route path="trade-points" element={<TradePoint/>}/>
                                                <Route path="trade-points/trade-point" element={<EditTradePoint/>}/>

                                                {/*TradePoint Routes*/}
                                                <Route path="routes" element={<TRoute/>}/>
                                                <Route path="routes/:route_id" element={<EditTRoute/>}/>

                                                {/*TradePoint Chains*/}
                                                <Route path="trade-points/chains"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <Chain/>
                                                       </ProtectedRoute>}
                                                />
                                                <Route path="trade-points/chains/chain"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditChain/>
                                                       </ProtectedRoute>}
                                                />

                                                {/*TradePoint Type*/}
                                                <Route path="trade-points/types"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <TradePointType/>
                                                       </ProtectedRoute>}
                                                />
                                                <Route path="trade-points/types/type"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditTradePointsType/>
                                                       </ProtectedRoute>}
                                                />

                                                {/*TradePoints Category*/}
                                                <Route path="trade-points/categories"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <TradePointCategory/>
                                                       </ProtectedRoute>}
                                                />
                                                <Route path="trade-points/categories/category"
                                                       element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                           <EditTradePointsCategory/>
                                                       </ProtectedRoute>}
                                                />


                                                <Route path="documents-settings">
                                                    {/* Reporting periods*/}
                                                    <Route path="reporting-periods"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <ReportingPeriod/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="reporting-periods/reporting-period"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditReportingPeriod/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*Types Reporting periods*/}
                                                    <Route path="reporting-periods/types"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <TypeReportingPeriod/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="reporting-periods/types/type"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditTypeReportingPeriod/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*Pattern Activity*/}
                                                    <Route path="pattern-activities"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <PatternActivity/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="pattern-activities/:pattern_activity_id"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditPatternActivity/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*Doc Type*/}
                                                    <Route path="types"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <DocType/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="types/type"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditDocType/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*Doc Type*/}
                                                    <Route path="units"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <Unit/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="units/unit"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditUnit/>
                                                           </ProtectedRoute>}
                                                    />
                                                </Route>

                                                <Route path="documents">
                                                    {/*Sales*/}
                                                    <Route path="sales" element={<Sales/>}/>
                                                    <Route path="sales/:sale_id" element={<Sale/>}/>
                                                    <Route path="sales/:sale_id/edit" element={<EditSale/>}/>

                                                    {/*Remain*/}
                                                    <Route path="remains" element={<Remain/>}/>
                                                    <Route path="remains/remain" element={<EditRemain/>}/>
                                                </Route>



                                                <Route path={'reports'}>
                                                    <Route path={'sales'} element={<ReportSales/>}/>
                                                </Route>


                                                {/*Equipment*/}
                                                {/*<Route path="equipments" element={<Equipment/>}/>*/}


                                                <Route path="admin">
                                                    {/*Admin*/}
                                                    <Route path="users"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <Users/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route
                                                        path="users/user"
                                                        element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                            <EditUser/>
                                                        </ProtectedRoute>}
                                                    />

                                                    <Route path="mailing"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <NewsMailing/>
                                                           </ProtectedRoute>}
                                                    />
                                                    <Route path="mailing/:mailing_id"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <EditNewsMailing/>
                                                           </ProtectedRoute>}
                                                    />

                                                    <Route path="cube"
                                                           element={<ProtectedRoute isAllowed={user.role_id === 1}>
                                                               <Cube/>
                                                           </ProtectedRoute>}
                                                    />

                                                    {/*<Route path="change_log"*/}
                                                    {/*       element={<ProtectedRoute isAllowed={user.role_id === 1}>*/}
                                                    {/*           <ChangeLog/>*/}
                                                    {/*       </ProtectedRoute>}*/}
                                                    {/*/>*/}
                                                </Route>

                                                <Route path="user/settings" element={<UserSettings/>}/>

                                                <Route path="development">
                                                    <Route path="logs" element={<Log/>}/>
                                                    <Route path="logs/:log_id" element={<EditLog/>}/>
                                                    <Route path="documentation" element={<Documentation/>}/>

                                                    <Route path="logs_mobile" element={<LogsMobiles/>}/>
                                                    <Route path="logs_mobile/:session_id" element={<LogMobile/>}/>

                                                </Route>

                                                <Route path={'app'}>

                                                    <Route path={'availability'} element={<RemainsMobile/>}/>
                                                    <Route path={'availability/:availability_id'} element={<RemainMobile/>}/>

                                                    <Route path={'orders'} element={<Orders/>}/>
                                                    <Route path={'orders/:order_id'} element={<Order/>}/>
                                                    <Route path={'orders/:order_id/edit'} element={<EditOrder/>}/>


                                                    <Route path={'payments'} element={<Payments/>}/>
                                                    <Route path={'payments/:payment_id'} element={<Payment/>}/>

                                                    <Route path={'returns'} element={<Returns/>}/>
                                                    <Route path={'returns/:return_id'} element={<Return/>}/>
                                                    <Route path={'returns/:return_id/edit'} element={<EditReturn/>}/>

                                                    <Route path={'remains_trade_points'} element={<RemainsTradePoints/>}/>
                                                    <Route path={'remains_trade_points/:remains_trade_point_id'} element={<RemainsTradePoint/>}/>

                                                    <Route path={'visits'} element={<Visits/>}/>
                                                    <Route path={'visits/:visit_id'} element={<Visit/>}/>

                                                </Route>
                                            </Route>
                                        </Routes>
                                    </Content>
                                </Layout>
                            </Layout>
                        </Context.Provider>
                    </Suspense>
                </ConfigProvider>
            </>
        )
    }
}

export default App;
